import React from 'react';
import './propstatus.css'
const Status = (props) => {
    return ( <div className={props.status}>
        {props.text}
 </div> );
}
 
export default Status;